import { InventoryController, TransactionsController } from '../../controllers';
import React, { useEffect, useMemo, useState } from 'react';
import { useStores } from '../../stores';
import { Inventory } from '../../pages';
import { observer } from 'mobx-react';
import { theYear } from '../../utils/utils';
import { date, object } from 'yup';

const InventoryContainer = () => {
	const [addProductModal, setAddProductModal] = useState(false);
	const [addStockModal, setOpenAddStockModal] = useState(false);
	const [addRateCardModal, setOpenAddRateCardModal] = useState(false);
	const [updateRateCardModal, setOpenUpdateRateCardModal] = useState(false);
	const [editStockModal, setOpenEditStockModal] = useState(false);
	const [addBulkProducts, setAddBulkProducts] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [openEditModal, setOpenEditModal] = useState(false);
	const [openLinkModal, setOpenLinkModal] = useState(false);
	const [openViewMoreModal, setOpenViewMoreModal] = useState(false);
	const [tableType, setTableType] = useState('Product Type');
	const [loading, setLoading] = useState(false);
	const [openDeleteProductModal, setOpenDeleteProductModal] = useState(false);
	const [addVariation, setAddVariation] = useState(false);
	const [activityTrailModal, setActivityTrailModal] = useState(false);
	const [updateQtyModal, setUpdateQtyModal] = useState(false);
	const [openViewMoreStock, setOpenViewMoreStock] = useState(false);

	const { getStockAnalysis } = InventoryController;

	const { inventoryStore, transactionStore } = useStores();

	const handleOptionSelect = (_id, product, option) => {
		inventoryStore.setSelectedProduct(product);
		if (option.value === 'delete') {
			setOpenDeleteProductModal(true);
		} else if (option.value === 'edit') {
			setOpenEditModal(true);
		} else if (option.value === 'share link') {
			setOpenLinkModal(true);
		} else if (option.value === 'view more') {
			setOpenViewMoreModal(true);
		} else if (option.value === 'add variation') {
			setOpenAddStockModal(true);
		}
	};

	const showAddVariationModal = () => {
		setAddVariation(true);
	};

	const showAddBulkProductsModal = () => {
		setAddBulkProducts(true);
	};

	const showDeleteProductModal = product => {
		inventoryStore.setSelectedProduct(product);
		setOpenDeleteModal(true);
	};

	const handleStockOptionSelect = (_id, stock, option) => {
		inventoryStore.setSelectedStock(stock);
		if (option.value === 'Delete Stock') {
			setOpenDeleteModal(true);
		} else if (option.value === 'Edit Stock') {
			setOpenEditStockModal(true);
		} else if (option.value === 'Activity Trail') {
			setActivityTrailModal(true);
		} else if (option.value === 'Update Quantity') {
			setUpdateQtyModal(true);
		} else if (option.value === 'View More') {
			setOpenViewMoreStock(true);
		}
	};

	const handleRateCardOptionSelect = (_id, rateCard, option) => {
		inventoryStore.setSelectedRateCard(rateCard);
		if (option.value === 'Update Rate Card') {
			setOpenUpdateRateCardModal(true);
		}
	};

	useEffect(() => {
		const setTransactions = async () => {
			setLoading(true);
			await Promise.all([getStockAnalysis()]);
			setLoading(false);
		};
		setTransactions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const refresh = async () => {
		setLoading(true);
		await Promise.all([getStockAnalysis()]);
		setLoading(false);
	};

	const closeModal = () => {
		setAddProductModal(false);
		setOpenEditStockModal(false);
		setOpenDeleteModal(false);
		setOpenEditModal(false);
		setOpenDeleteProductModal(false);
		setOpenLinkModal(false);
		setOpenViewMoreModal(false);
		setOpenAddStockModal(false);
		setAddVariation(false);
		setActivityTrailModal(false);
		setUpdateQtyModal(false);
		setOpenViewMoreStock(false);
		setOpenAddRateCardModal(false);
		setOpenUpdateRateCardModal(false);
		setAddBulkProducts(false);
		inventoryStore.setSelectedProduct({});
		inventoryStore.setSelectedStock({});
		inventoryStore.setSelectedRateCard({});
		transactionStore.setSelectedSplitTrans({});
	};

	const showAddProductModal = () => {
		setAddProductModal(true);
	};

	const showAddRateCardModal = () => {
		setOpenAddRateCardModal(true);
	};

	const [filterPeriod, setFilterPeriod] = useState(`${theYear}`);

	const validationSchema = () => {
		return object({
			startDate: date().required('Start Date is required'),
			endDate: date().required('End Date is required'),
		});
	};

	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}&dateField=createdAt`;
			setFilterPeriod(
				`${payload?.startDate.toDateString()} - ${payload.endDate.toDateString()}`
			);
		}
		setLoading(true);
		await Promise.all([
			TransactionsController.transactionSummary(query),
			TransactionsController.expenseAnalysis(query),
		]);
		setLoading(false);
	};

	const resetFilter = async () => {
		await onSubmit();
		setFilterPeriod(`${theYear}`);
	};

	//Update to Inventory Product type Table
	const [productLimit, setProductLimit] = useState(500);
	const [productFilterQuery, setProductFilterQuery] = useState('');
	const [productCurrentPage, setProductCurrentPage] = useState(0);
	const [productSearchQuery, setProductSearchQuery] = useState('');
	const [stockStatus, setStockStatus] = useState('');

	const productTypeTableQuery = useMemo(() => {
		return `offset=${productCurrentPage + 1}&limit=${productLimit}`;
	}, [productCurrentPage, productLimit]);

	const productDataInfo = InventoryController.useProductTypeList(
		productTypeTableQuery,
		productFilterQuery,
		productSearchQuery
	);

	const onProductLimitChange = limit => {
		setProductLimit(limit);
		setProductCurrentPage(0);
	};

	//Update tto Inventory Stock type Table
	const [stockLimit, setStockLimit] = useState(500);
	const [stockfilterQuery, setStockFilterQuery] = useState('');
	const [stockCurrentPage, setStockCurrentPage] = useState(0);
	const [stockSearchQuery, setStockSearchQuery] = useState('');

	// const stockTableQuery = useMemo(() => {
	// 	return `offset=${stockCurrentPage + 1}&limit=${stockLimit}`;
	// }, [stockCurrentPage, stockLimit]);

	const stockTableQuery = useMemo(() => {
		let queryString = `offset=${stockCurrentPage + 1}&limit=${stockLimit}`;

		if (stockStatus !== '') {
			queryString += `&status=${encodeURIComponent(stockStatus)}`;
		}

		return queryString;
	}, [stockCurrentPage, stockLimit, stockStatus]);

	const stockDataInfo = InventoryController.useStockList(
		stockTableQuery,
		stockfilterQuery,
		stockSearchQuery
	);

	const onStockLimitChange = limit => {
		setStockLimit(limit);
		setStockCurrentPage(0);
	};

	//Update tto Inventory Stock type Table
	const [rateCardLimit, setRateCardLimit] = useState(50);
	const [rateCardfilterQuery, setRateCardFilterQuery] = useState('');
	const [rateCardCurrentPage, setRateCardCurrentPage] = useState(0);
	const [rateCardSearchQuery, setRateCardSearchQuery] = useState('');

	// const rateCardTableQuery = useMemo(() => {
	// 	return `offset=${rateCardCurrentPage + 1}&limit=${rateCardLimit}`
	// }, [rateCardCurrentPage, rateCardLimit])

	// const rateDataInfo = InventoryController.useGetRateCardList(rateCardTableQuery, rateCardfilterQuery, rateCardSearchQuery);

	const rateCardTableQuery = useMemo(() => {
		return `offset=${rateCardCurrentPage + 1}&limit=${rateCardLimit}`;
	}, [rateCardCurrentPage, rateCardLimit]);

	const rateDataInfo = InventoryController.useGetRateCardList(
		rateCardTableQuery,
		rateCardfilterQuery,
		rateCardSearchQuery
	);

	const onRateCardLimitChange = limit => {
		setRateCardLimit(limit);
		setRateCardCurrentPage(0);
	};

	return (
		<Inventory
			editStockModal={editStockModal}
			tableType={tableType}
			handleStockOptionSelect={handleStockOptionSelect}
			setTableType={setTableType}
			addStockModal={addStockModal}
			handleOptionSelect={handleOptionSelect}
			openViewMoreModal={openViewMoreModal}
			openLinkModal={openLinkModal}
			openDeleteModal={openDeleteModal}
			addProductModal={addProductModal}
			openEditModal={openEditModal}
			showAddProductModal={showAddProductModal}
			openDeleteProductModal={openDeleteProductModal}
			closeModal={closeModal}
			refresh={refresh}
			showDeleteProductModal={showDeleteProductModal}
			addVariation={addVariation}
			showAddVariationModal={showAddVariationModal}
			filterPeriod={filterPeriod}
			resetFilter={resetFilter}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			activityTrailModal={activityTrailModal}
			updateQtyModal={updateQtyModal}
			openViewMoreStock={openViewMoreStock}
			addRateCardModal={addRateCardModal}
			updateRateCardModal={updateRateCardModal}
			showAddRateCardModal={showAddRateCardModal}
			handleRateCardOptionSelect={handleRateCardOptionSelect}
			showAddBulkProductsModal={showAddBulkProductsModal}
			addBulkProducts={addBulkProducts}
			isLoading={productDataInfo.isLoading}
			isFetching={productDataInfo.isFetching}
			//Product type
			onProductLimitChange={onProductLimitChange}
			productLimit={productDataInfo.limit}
			productCurrentPage={productCurrentPage}
			setProductCurrentPage={setProductCurrentPage}
			productDataInfo={productDataInfo.data}
			setProductSearchQuery={setProductSearchQuery}
			//Stock
			onStockLimitChange={onStockLimitChange}
			stockLimit={stockLimit}
			stockCurrentPage={stockCurrentPage}
			setStockCurrentPage={setStockCurrentPage}
			setStockSearchQuery={setStockSearchQuery}
			stockDataInfo={stockDataInfo}
			//Rate Card
			onRateCardLimitChange={onRateCardLimitChange}
			setRateCardSearchQuery={setRateCardSearchQuery}
			rateCardInfo={rateDataInfo}
			rateCardLimit={rateCardLimit}
			rateCardCurrentPage={rateCardCurrentPage}
			setRateCardCurrentPage={setRateCardCurrentPage}
			setStockStatus={setStockStatus}
			loading={loading}
		/>
	);
};

export default observer(InventoryContainer);
